module.exports = __webpack_public_path__ + "img/12830392-2xiaokangd59-4ac5-9a44-5f4401e04231.f157d23a.jpg";